import React from "react";
import "./produk.scss";
import Rumahmilenial from "./rumahmilenial/rumahmilenial.jsx";
import Cbd from "./cbd/cbd.jsx";
import Centerpoin from "./centerpoin/centerpoin.jsx";
import Pik1 from "./pik1/pik1.jsx";
import Commercialpik from "./commercialpik/commercialpik.jsx";
import Kavres from "./kavres/kavres.jsx";
import Ginza from "./ginza/ginza.jsx";
import fasilitas from "../../asset/fasilitas/fasilitas.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Casapasadena from "./casapasadena/casapesadena.jsx";
import Ilona from "./illonapasadena/ilona.jsx";

const Produk = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    lazyload: true,
    autoplay: true,
    speed: 1000,

    responsive: [
      {
        breakpoint: 768, // Adjust breakpoint for your mobile size
        settings: {
          slidesToShow: 1,
          arrows: false,
          lazyload: true,
          autoplay: true, // Show only 1 slide on mobile screens
        },
      },
    ],
  };
  return (
    <div id="produk" className="produk">
      <div className="container-produk">
        <div className="container">
          <div className="header-produk">
            <div className="judul-produk">Our Masterpiece</div>
          </div>
          <div className="carousel-produk">
            <Slider {...settings}>
              {fasilitas.map((image, index) => (
                <img
                  className="kartugambar"
                  key={index}
                  src={image}
                  alt="fasilitas"
                />
              ))}
            </Slider>
          </div>
        </div>
        <Casapasadena />
        <Ilona />
        <Rumahmilenial />
        <Cbd />
        <Centerpoin />
        <Pik1 />
        <Commercialpik />
        <Kavres />
        <Ginza />
      </div>
    </div>
  );
};

export default Produk;
